import { ButtonStyles } from './styles/button';

export const Button = ({children, ...rest}) => <ButtonStyles {...rest}>{children}</ButtonStyles>
